import styled, { css } from 'styled-components';
import ReactImageZoom from 'react-image-zoom';

const GalleryImage = styled(ReactImageZoom)`
  max-height: 70vh;
`;

const ZoomContainer = styled.div`
  position: absolute;
  top: 5vh;
  width: 20vh;
  right: 20px;
`;

const StyledSidePanel = styled.div`
  padding-left: 320px;

  @media all and (min-width: 768px) {
    .SidePanel__overlay {
      padding-left: 120px;
    }
  }
  @media all and (min-width: 992px) {
    .SidePanel__overlay {
      padding-left: 320px;
    }
  }
`;

export const S = {
  GalleryImage,
  ZoomContainer,
  StyledSidePanel,
};

export const Container = styled.div`
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
  margin-right: auto;
  margin-left: auto;
`;

export const Row = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-right: -15px;
  margin-left: -15px;
`;

export const Col = styled.div`
  ${({ md4 }) =>
    md4 &&
    css`
      @media (min-width: 768px) {
        flex: 0 0 auto;
        width: 33.33333333%;
      }
    `}
  ${({ md8 }) =>
    md8 &&
    css`
      @media (min-width: 768px) {
        flex: 0 0 auto;
        width: 66.66666667%;
      }
    `}
`;
